module.exports = __webpack_public_path__ + "img/symbol_3.535b27bb.png";